// Definição para o modal de busca de Unidades de Medida da lista de cliente/sistema
// (prefixo UN_MED). Usada para itens que NÃO controlam estoque (serviços), que podem
// escolher QUALQUER unidade da lista — sem depender das conversões do produto.
//
// displayField = textoLista (texto exibido no input)
// descField    = textoLista (descrição no label informativo)
// idField      = idListaClienteItem (código da lista, salvo como modelValue)
//
// Endpoint: GET /ListasCliente/itensBusca?pageNumber&pageSize&prefixoCabecalho&busca&lstStatus

import { ST } from '@/constants/ST'

export const criarConfigBuscaUnidadeMedidaCliente = (prefixo = 'UN_MED') => ({
  label: 'Unidade de Medida',
  placeholder: 'Buscar unidade...',
  titulo: 'Unidades de Medida',
  endpointApi: 'ListasCliente/itensBusca',
  idField: 'idListaClienteItem',
  displayField: 'textoLista',
  descField: 'textoLista',
  colunasGrid: [
    { header: 'Unidade', dataField: 'textoLista', width: '120px' },
    { header: 'Descrição', dataField: 'descricaoItem', width: '260px' }
  ],
  camposFiltro: [
    { label: 'Buscar unidade...', model: 'busca', tipo: 'text' }
  ],
  filtrosFixos: { prefixoCabecalho: prefixo, lstStatus: ST.Ativo }
})
